import { ClusterService } from '@qdrant/qdrant-cloud-public-api/cluster/v1';
import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { clusterService } from '@/api/services/cluster';
import { CLOUD_PROVIDER_MAP } from '@/components/Clusters/constants';
import { head } from '@/router/Head';
import { resolveAccountHasRpcPermissions } from '@/router/resolvers/user';

/**
 * The full-page gate is the parent route's `getHybridCloudEnvironment` fetch: the permissions interceptor
 * throws an `AccessControlError` — rendered as "Access Denied" — before the request goes out, and the
 * parent rethrows it (its catch only turns API 403/404 responses into a redirect to the environment list).
 */
export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/overview',
)({
  beforeLoad: async ({ context: { queryClient }, params: { accountId } }) => ({
    // Used to prefetch clusters
    hasClusterReadPermissions: await resolveAccountHasRpcPermissions([ClusterService.method.listClusters], {
      queryClient,
      accountId,
    }),
  }),
  loader: ({ context: { queryClient, hasClusterReadPermissions }, params: { accountId, hybridCloudEnvId } }) => {
    if (hasClusterReadPermissions) {
      void queryClient.prefetchQuery(
        clusterService.listClustersQuery({
          accountId,
          cloudProviderId: CLOUD_PROVIDER_MAP.HYBRID,
          cloudProviderRegionId: hybridCloudEnvId,
        }),
      );
    }
  },
  head,
  staticData: {
    title: ['Hybrid Cloud Environment', 'Overview'],
  },
  component: lazyRouteComponent(() => import('./overview.component'), 'HybridCloudEnvOverviewComponent'),
  pendingComponent: lazyRouteComponent(
    () => import('@/components/HybridCloudEnvironments/OverviewTab/OverviewTabSkeleton'),
    'HybridCloudEnvOverviewSkeleton',
  ),
});
